export default {
    data() {
        return {
            pagination: {
                limit: 12,
                page: 1,
                totalRecords: null,
            },
        }
    },
    methods: {
        setupPage() {
            this.pagination.page = parseInt(this.$route.query.page ?? '1')
        }
    }
}